import React from 'react';
import { 
  Building, 
  Store, 
  Hammer, 
  Heart, 
  Home, 
  Zap, 
  Pickaxe, 
  CheckCircle,
  Clock,
  Train
} from 'lucide-react';
import './Services.css';

const Services: React.FC = () => {
  const serviceTree = [
    {
      category: "Essential Resources",
      icon: Building,
      items: [
        { name: "Power Grid", description: "Free electricity to all plots", icon: Zap, available: true },
        { name: "Infinite Lava", description: "Free Lava to all personal plots", icon: Home, available: true },
        { name: "Railway Access", description: "Access to the railway system", icon: Train, available: false },
      ]
    },
    {
      category: "Shops",
      icon: Store,
      items: [
        { name: "Own Shops", description: "Make your own shop in the town center", icon: Store, available: true }
      ]
    },
    {
      category: "Additional Resources",
      icon: Hammer,
      items: [
        { name: "Workshop", description: "Accessible workshop for everyone", icon: Hammer, available: true },
        { name: "Block Factory", description: "Get Blocks like stone, cobblestone, dirt, grass, and more.", icon: Pickaxe, available: true },
        { name: "Crop Farms", description: "A variety of crops to grow", icon: Heart, available: false },
      ]
    },
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="services-header">
          <h2 className="section-title">What We Provide</h2>
          <p className="section-description">
            A comprehensive overview of all services, facilities, and resources available in our thriving Minecraft community.
          </p>
        </div>
        
        <div className="services-tree">
          {serviceTree.map((category, categoryIndex) => (
            <div key={categoryIndex} className="service-category">
              <div className="category-header">
                <div className="category-icon">
                  <category.icon size={24} />
                </div>
                <h3 className="category-title">{category.category}</h3>
              </div>
              
              <div className="category-items">
                {category.items.map((item, itemIndex) => (
                  <div key={itemIndex} className={`service-item ${item.available ? 'available' : 'coming-soon'}`}>
                    <div className="item-connector">
                      <div className="connector-line"></div>
                      <div className="connector-dot"></div>
                    </div>
                    
                    <div className="item-content">
                      <div className="item-header">
                        <div className="item-icon">
                          <item.icon size={20} />
                        </div>
                        <h4 className="item-name">{item.name}</h4>
                        <div className="item-status">
                          {item.available ? (
                            <CheckCircle size={16} className="status-available" />
                          ) : (
                            <Clock size={16} className="status-coming-soon" />
                          )}
                        </div>
                      </div>
                      <p className="item-description">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        
        <div className="services-footer">
          <div className="legend">
            <div className="legend-item">
              <CheckCircle size={16} className="status-available" />
              <span>Available Now</span>
            </div>
            <div className="legend-item">
              <Clock size={16} className="status-coming-soon" />
              <span>Coming Soon</span>
            </div>
          </div>
          <p className="footer-note">
            Our town is constantly growing! New services and facilities are added regularly based on community needs.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Services; 